export function parseNumberWithCommas (value) {
  return Number(value?.toString().replaceAll(",", "") || 0);
}
